import React, {cloneElement} from 'react';
import {useSortable,} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import SquareImageViewBox from "@/components/common/SquareImageViewBox";

function SortableItem({isActive, id, value, ...props}:any) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable(
        {id: id}
    );

    const propStyle = props?.style ? props?.style : {}

    const style = {
        opacity: isActive ? 0.3 : 1,
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <div ref={setNodeRef} style={{...propStyle, ...style}} {...attributes} {...listeners}>
            {/* ... */}
            {props.children ? cloneElement(props.children, {...props}) : (value || id)}
        </div>
    )
}

export default SortableItem;